import { useNavigate } from 'react-router-dom';

import { PromptPageTabs } from '../constants';

interface UseRepoNavigationProps {
  owner: string | undefined;
  repo: string;
  inHub: boolean;
  latestCommitHash: string;
}

export const useRepoNavigation = (props: UseRepoNavigationProps) => {
  const navigate = useNavigate();

  const navigateToTab = (index: number, commitHash?: string) => {
    const baseUrl = `/${props.inHub ? `hub/${props.owner}` : 'prompts'}/${
      props.repo
    }`;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('tab', index.toString());
    const queryString = `?${searchParams.toString()}`;

    if (index === PromptPageTabs.COMMITS) {
      const hash = commitHash || props.latestCommitHash;
      navigate(`${baseUrl}/${hash}${queryString}`);
    } else {
      navigate(`${baseUrl}${queryString}`);
    }
  };

  return { navigateToTab };
};
